import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * useScrollToTop Hook
 *
 * @param {Object} options - Opsiyonel ayarlar
 * @param {boolean} options.smooth - Smooth scroll kullanılsın mı (default: false)
 */
const useScrollToTop = (options = {}) => {
  const { smooth = false } = options;
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: smooth ? "smooth" : "auto" });
  }, [location.pathname, smooth]);
};

export default useScrollToTop;
